(function () {
    'use strict';

    var forms = document.querySelectorAll('.js-contact-form');
    if (!forms.length) return;

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function validatePhone(phone) {
        if (!phone) return true;
        return /^(\+420|00420)?\s?[1-9][0-9]{2}\s?[0-9]{3}\s?[0-9]{3}$/.test(phone);
    }

    function showAlert(form, message, isError) {
        var alertEl = form.querySelector('.cf__alert');
        var textEl = form.querySelector('.cf__alert-text');
        if (!alertEl || !textEl) return;
        textEl.textContent = message;
        alertEl.className = 'cf__alert' + (isError ? ' cf__alert--error' : ' cf__alert--success');
        alertEl.style.display = 'block';
    }

    function hideAlert(form) {
        var alertEl = form.querySelector('.cf__alert');
        if (alertEl) alertEl.style.display = 'none';
    }

    function handleOffcanvasSuccess(form) {
        var offcanvas = form.closest('.offcanvas');
        if (!offcanvas) return false;

        var bodyEl = offcanvas.querySelector('.offcanvas__body');
        var successEl = offcanvas.querySelector('.offcanvas__success');

        if (!successEl) return false;

        if (bodyEl) bodyEl.style.display = 'none';
        successEl.classList.add('active');

        if (typeof gsap !== 'undefined') {
            gsap.fromTo(successEl.children,
                { y: 20, opacity: 0 },
                { y: 0, opacity: 1, stagger: 0.1, duration: 0.6, ease: 'power3.out' }
            );
        }

        return true;
    }

    forms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            hideAlert(form);

            var nameInput  = form.querySelector('[name="name"]');
            var emailInput = form.querySelector('[name="email"]');
            var phoneInput = form.querySelector('[name="phone"]');

            if (!nameInput || !nameInput.value.trim() || !emailInput || !emailInput.value.trim()) return;

            if (!validateEmail(emailInput.value.trim())) {
                showAlert(form, 'Neplatná e-mailová adresa.', true);
                return;
            }

            if (phoneInput && phoneInput.value.trim() && !validatePhone(phoneInput.value.trim())) {
                showAlert(form, 'Neplatné telefonní číslo.', true);
                return;
            }

            var source = form.dataset.source || 'kontaktni-stranka';

            function submitForm(token) {
                var formData = new FormData(form);
                formData.append('action', 'handle_contact_form_submission');
                formData.append('source', source);
                formData.append('nonce', MyAjax.nonce);
                formData.append('recaptcha_response', token);

                jQuery.ajax({
                    url: MyAjax.ajaxurl,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if (response.success) {
                            // GTM dataLayer push
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'form_submit',
                                form: 'contact-form',
                                source: source
                            });

                            // Offcanvas → success panel; page → inline alert
                            if (!handleOffcanvasSuccess(form)) {
                                showAlert(form, response.data || 'Zpráva byla odeslána. Děkujeme!', false);
                                form.reset();
                            }
                        } else {
                            showAlert(form, response.data || 'Nastala chyba, zkuste to prosím znovu.', true);
                        }
                    },
                    error: function (xhr) {
                        var msg = xhr.responseJSON ? xhr.responseJSON.data : null;
                        showAlert(form, msg || 'Nastala chyba, zkuste to prosím znovu.', true);
                    }
                });
            }

            // Get fresh reCAPTCHA token before submit
            if (typeof grecaptcha !== 'undefined' && MyAjax.recaptcha_site_key) {
                grecaptcha.execute(MyAjax.recaptcha_site_key, { action: 'submit' })
                    .then(function (token) { submitForm(token); })
                    .catch(function () { submitForm(''); });
            } else {
                submitForm('');
            }
        });
    });
})();
